import React from 'react';

import '@dsl/loop-next-fonts';
import { BaseWithoutSprite } from '@dsl/loop-next-react';
import '@dsl/loop-next-react/dist/index.css';

import './src/styles/global.css';

export const wrapPageElement = ({ element }) => <BaseWithoutSprite>{element}</BaseWithoutSprite>;
